import { Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import {
  DistributorsService,
  ProductsDistributorsService,
  RootService,
  ProductsService,
} from "../../../../services";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { ActivatedRoute, Params } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { publishReplay, takeUntil } from "rxjs/operators";
import { Location } from "@angular/common";

@Component({
  selector: "app-products-distributors",
  templateUrl: "./products-distributors.component.html",
  styleUrls: ["./products-distributors.component.scss"],
})
export class ProductsDistributorsComponent implements OnInit, OnDestroy {
  pageIndex = 1;
  pageSize = 10;
  loading = false;
  total: number;
  changeAction;
  actions = [
    { label: "Export", value: 0 },
    { label: "Export tất cả", value: 1 },
  ];
  statusList = [
    { label: "Đã duyệt", value: 1 },
    { label: "Chờ duyệt", value: 2 },
    { label: "Từ chối", value: 3 },
  ];
  isAllDisplayDataChecked = false;
  isIndeterminate = false;
  listOfDisplayData: any[] = [];
  listOfAllData: any[] = [];
  mapOfCheckedId: { [key: string]: boolean } = {};
  imageFalse = [];
  productId;
  // @ts-ignore
  @ViewChild("modal") modal;
  // @ts-ignore
  @ViewChild("modalDelete") modalDelete;
  // @ts-ignore
  @ViewChild("addDistributors") addDistributors;
  ids: any[] = [];
  unsubscribe$ = new Subject<void>();
  businessId;
  name;
  area;
  locationNewId;
  distributionType;
  status;
  city: any;
  city1: any;
  listRole;
  query;

  constructor(
    private productsDistributorsService: ProductsDistributorsService,
    private notification: NzNotificationService,
    private distributorsService: DistributorsService,
    private rootService: RootService,
    private productService: ProductsService,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  managementStatus: number;
  roleCode: string = null;

  clearPosParam() {
    // @ts-ignore
    this.location.replaceState(this.location.path().split("?")[0], "");
  }
  ngOnInit() {
    this.productId = window.location.href.split("/")[5];
    this.rootService
      .listCities()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.city = res.data.items;
      });
    this.rootService
      .getLocationNew({type: 1})
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.city1 = res.data.data;
      });
    this.distributorsService
      .listRole()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.listRole = res.data;
      });

    this.activatedRoute.queryParams
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((params) => {
        if (params.name !== undefined) {
          this.clearPosParam();
          this.name = params.name;
        }
        this.loadData();
      });

    this.productService
      .getById(this.productId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res.code === 1) {
          this.managementStatus = res.data.managementStatus;
          this.roleCode = res.data.roleCode;
          let body: any = {
            managementStatus: this.managementStatus,
            roleCode: this.roleCode,
          };
          this.productService.getManagementStatus(body);
        }
      });
  }

  async loadData(ms = 0) {
    this.loading = true;
    await this.sleep(ms);
    this.query = {
      locationId: this.area ? this.area : "",
      locationNewId: this.locationNewId ? this.locationNewId : "",
      name: this.name ? this.name.trim() : "",
      product_id: this.productId,
      distributorType: this.distributionType ? this.distributionType : "",
      status: this.status ? this.status : "",
      page: this.pageIndex,
      page_size: this.pageSize,
    };
    this.productsDistributorsService
      .listDistributor(this.query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          this.loading = false;
          this.total = res.data.totalElement;
          this.listOfAllData = res.data.items;

          if (res.data.items.length === 0 && this.pageIndex > 1) {
            this.pageIndex = this.pageIndex - 1;
            this.loadData();
          }
        },
        (err) => {
          this.loading = false;
          this.notification.create("error", "Thất bại", err);
        }
      );
  }

  search() {
    this.pageIndex = 1;
    this.loadData();
  }

  reset() {
    this.pageIndex = 1;
    this.name = undefined;
    this.distributionType = undefined;
    this.area = undefined;
    this.locationNewId = undefined;
    this.status = undefined;
    this.loadData();
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  currentPageDataChange($event: any[]): void {
    this.listOfDisplayData = $event;
    this.refreshStatus();
  }

  refreshStatus(): void {
    if (this.listOfDisplayData.length > 0) {
      this.isAllDisplayDataChecked = this.listOfDisplayData.every(
        (item) => this.mapOfCheckedId[item.id]
      );
    } else {
      this.isAllDisplayDataChecked = false;
    }
    this.isIndeterminate =
      this.listOfDisplayData.some((item) => this.mapOfCheckedId[item.id]) &&
      !this.isAllDisplayDataChecked;
    this.ids = [];
    for (const [key, value] of Object.entries(this.mapOfCheckedId)) {
      if (value == true) {
        this.ids.push(key);
      }
    }
  }

  checkAll(value: boolean): void {
    this.listOfDisplayData.forEach(
      (item) => (this.mapOfCheckedId[item.id] = value)
    );
    this.refreshStatus();
  }

  loadDataChild($event: any) {
    this.loadData(1000);
  }

  editDistributor(id: any) {
    const query = {
      business_id: id,
      product_id: this.productId,
    };
    this.productsDistributorsService
      .detailDistributor(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.modal.showModal(res.data, id, this.productId);
      });
  }

  actionsButton() {
    if (this.changeAction === "1") {
      this.addDistributors.showModal();
    }
    if (this.changeAction === "2") {
      this.deleteProduct();
    }
    if (this.changeAction === "3") {
      this.exportExcel();
    }
  }

  /*Check link image error*/
  checkImageErr(imageError) {
    this.imageFalse.push(imageError);
  }

  showImage(id: any, imageLink) {
    if (!this.imageFalse.includes(id)) {
      window.open(imageLink, "_blank");
    }
  }

  /*End Check link image error*/

  /*Modal delete*/
  setName(data) {
    this.businessId = data.id;
    const text = {
      label: "Xóa nhà phân phối",
      value:
        ' <p class="mrb-10">Hệ thống sẽ gỡ toàn bộ sản phẩm của bạn khỏi nhà phân phối <span class="colorDelete">' +
        data.name +
        "</span>. Bạn có chắc chắn muốn xoá nhà phân phối?</p>\n",
    };
    this.modalDelete.showModal(text, data.id);
  }

  eventDelete(value) {
    const body = {
      body: {
        productId: this.productId,
        ids: value,
      },
    };
    this.productsDistributorsService
      .deleteDistributor(body)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (res) => {
          if (res.code === 1) {
            this.notification.create(
              "success",
              "Thành công",
              "Xóa nhà phân phối thành công"
            );
            this.mapOfCheckedId = {};
            this.ids = [];
            this.modalDelete.handleCancel();

            this.loadData(500);
          } else {
            this.notification.create("warning", "Cảnh báo", res.message);
          }
          this.modalDelete.success();
        },
        (err) => {
          this.notification.create("error", "Thất bại", err);
          this.modalDelete.success();
        }
      );
  }

  deleteProduct() {
    const text = {
      label: "Xóa nhà phân phối",
      value: "<p>Bạn có chắc chắn muốn xoá danh sách nhà phân phối</p>",
    };
    this.modalDelete.showModal(text, this.ids);
  }

  /*End Modal delete*/

  exportExcel() {
    const query = {
      export_all: this.ids.length === 0,
      ids: this.ids.length !== 0 ? this.ids.toString() : "",
      locationId: this.area ? this.area : "",
      name: this.name ? this.name.trim() : "",
      product_id: this.productId,
      distributorType: this.distributionType ? this.distributionType : "",
      status: this.status ? this.status : "",
      page: this.pageIndex,
      pageSize: this.total,
    };
    this.productsDistributorsService
      .exportExcel(query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((data) => {
        this.rootService.export(
          data,
          "Danh sách nhà phân phối của sản phẩm.xlsx"
        );
      });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
